import { graphql } from 'gql';

export const priceListMtr = graphql(`
    query uerPriceListMtr(
        $skip: Int
        $take: Int
        $contractId: Long!
        $where: PriceListMtrRowDataFilterInput
        $order: [PriceListMtrRowDataSortInput!]
    ) {
        uerPriceListMtr(contractId: $contractId, skip: $skip, take: $take, where: $where, order: $order) {
            totalCount
            pageInfo {
                hasNextPage
                hasPreviousPage
            }
            items {
                id
                key
                code
                name
                unit
                unitCost
                supplyBy
                mtrType
                status
                volume
                unitWeight
                isIncludedInWorkOrder
                isIncludedInAct
                isIncludedInWorkOrderChange
                justification
            }
        }
    }
`);

export const priceListMtrKeyFilter = graphql(`
    query priceListMtrKeyFilter($skip: Int, $take: Int, $contractId: Long!, $where: PriceListMtrRowDataFilterInput) {
        uerPriceListMtr(contractId: $contractId, skip: $skip, take: $take, where: $where) {
            items {
                key
            }
        }
    }
`);

export const priceListMtrCodeFilter = graphql(`
    query uerPriceListMtrCodeFilter($contractId: Long!, $where: FilterValueOfStringFilterInput) {
        uerPriceListMtrCodeFilter(contractId: $contractId, where: $where, take: 1000) {
            items {
                value
            }
        }
    }
`);

export const priceListMtrNameFilter = graphql(`
    query uerPriceListMtrNameFilter(
        $contractId: Long!
        $where: FilterValueOfStringFilterInput
        $order: [FilterValueOfStringSortInput!]
    ) {
        uerPriceListMtrNameFilter(contractId: $contractId, where: $where, take: 1000, order: $order) {
            items {
                value
            }
            totalCount
        }
    }
`);

export const priceListMtrUnitFilter = graphql(`
    query uerPriceListMtrUnitFilter($contractId: Long!) {
        uerPriceListMtrUnitFilter(contractId: $contractId, take: 1000) {
            items {
                value
            }
            totalCount
        }
    }
`);

export const priceListMtrStatusFilter = graphql(`
    query uerPriceListMtrStatusFilter($contractId: Long!) {
        uerPriceListMtrStatusFilter(contractId: $contractId, take: 1000) {
            items {
                value
            }
            totalCount
        }
    }
`);

export const priceListMtrSupplyByFilter = graphql(`
    query uerPriceListMtrSupplyByFilter($contractId: Long!) {
        uerPriceListMtrSupplyByFilter(contractId: $contractId, take: 1000) {
            items {
                value
            }
            totalCount
        }
    }
`);

export const priceListMtrTypeFilter = graphql(`
    query uerPriceListMtrTypeFilter($contractId: Long!) {
        uerPriceListMtrTypeFilter(contractId: $contractId, take: 1000, order: [{ value: DESC }]) {
            items {
                value
            }
            totalCount
        }
    }
`);

export const priceListMtrJustificationFilter = graphql(`
    query uerPriceListMtrJustificationFilter($contractId: Long!, $where: FilterValueOfStringFilterInput) {
        uerPriceListMtrJustificationFilter(contractId: $contractId, where: $where, take: 1000) {
            items {
                value
            }
            totalCount
        }
    }
`);

export const priceListMtrRemoveUnusedRows = graphql(`
    mutation uerRemoveUnusedMtrRows($contractId: Long!) {
        uerRemoveUnusedMtrRows(contractId: $contractId) {
            data {
                count
            }
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);
